import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const templateLinks = [
    { to: '/freelance-contract-template', label: 'Freelance Contract Template' },
    { to: '/nda-template', label: 'NDA Template' },
    { to: '/consultancy-contract-template', label: 'Consultancy Contract Template' },
    { to: '/algemene-voorwaarden-generator', label: 'Algemene Voorwaarden Generator' },
    { to: '/freelance-contract-voorbeeld', label: 'Freelance Contract Voorbeeld' },
  ];

  return (
    <footer style={{ backgroundColor: '#2F4E6F' }} className="text-white mt-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div
                className="flex items-center justify-center rounded-full bg-white"
                style={{ width: '36px', height: '36px', padding: '6px' }}
              >
                <svg width="24" height="24" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M25 15 C25 12 27 10 30 10 L55 10 C72 10 85 23 85 40 C85 57 72 70 55 70 L40 70 L40 85 C40 88 38 90 35 90 L30 90 C27 90 25 88 25 85 L25 15 Z M40 25 L40 55 L55 55 C63.284 55 70 48.284 70 40 C70 31.716 63.284 25 55 25 L40 25 Z"
                    fill="#FF8C00"
                    fillRule="evenodd"
                  />
                </svg>
              </div>
              <span className="text-lg font-semibold tracking-tight">PACTORAE</span>
            </div>
            <p className="text-sm text-blue-200 leading-relaxed">
              Freelance contract generator voor België en Nederland. Snel, eenvoudig en juridisch correct voor zelfstandigen en zzp'ers.
            </p>
          </div>

          {/* Templates column */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-blue-200 mb-4">
              Contract Templates
            </h3>
            <ul className="space-y-2">
              {templateLinks?.map((link) => (
                <li key={link?.to}>
                  <Link
                    to={link?.to}
                    className="text-sm text-blue-100 hover:text-white transition-colors duration-150"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links column */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-blue-200 mb-4">
              Snel starten
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/contract-generator"
                  className="text-sm text-blue-100 hover:text-white transition-colors duration-150"
                >
                  Contract Generator
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-blue-500/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-blue-300">
            &copy; {new Date()?.getFullYear()} Pactorae. Alle rechten voorbehouden.
          </p>
          <p className="text-xs text-blue-300">
            Contracten zijn automatisch gegenereerd. Raadpleeg altijd een juridisch adviseur.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
